import request from '../../utils/request'
import { judgePermissions } from '@/utils/common.js'

const state = {}

const actions = {
    // 获取字典
    getDict({dispatch},data) {
        return new Promise((resolve)=>{
            judgePermissions(['dict:data:get']).then(res => {
                if (res) {
                    request({
                        url: `/api/dict?dict_type=${data}`,
                    }).then(data => {
                        resolve(data);
                    });
                }else {
                    resolve({data:null})
                }
            })
        })
    },

    // 获取科目管理列表
    getSubjectList({dispatch},data){
        return new Promise((resolve)=>{
            judgePermissions(['subject:subject:list']).then(res => {
                if (res) {
                    request({
                        url: `/api/subject/all`,
                        params: data
                    }).then((data)=>{
                        resolve(data);
                    })
                }else {
                    resolve({data:null})
                }
            })
        })
    },

    // 批量导入科目
    importSubject({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/subject/file`,
                method: "post",
                data: data,
                headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 创建科目
    postSubject({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/subject`,
                method: "post",
                data: data
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 编辑科目
    putSubject({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/subject/${data.id}`,
                method: "put",
                data: data
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 删除科目
    deleteSubject({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/subject/${data}`,
                method: "delete"
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 科目名称查重
    checkRepeatSubject({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/subject?name=${data}`,
            }).then((data)=>{
                resolve(data);
            })
        })
    },
}

export default {
    state,
    actions
}